import { Injectable } from "@angular/core";
import { Restangular } from "ngx-restangular";

@Injectable()
export class SupplierEvaluationService {
  constructor(private restangular: Restangular) {}

  public getSupplierEvaluationLinksTable() {
    return this.restangular.all("supplier_evaluation_links_table");
  }

  public generateSupplierExternalLink() {
    return this.restangular.all("generate_supplier_evaluation_link");
  }

  public updateSupplierExternalLink(id) {
    return this.restangular.one("se_supplier_evaluation_links/" + id);
  }

  public createSupplierEvaluationForm() {
    return this.restangular.all("se_supplier_evaluation_masters");
  }

  public getSupplierEvaluationsTable() {
    return this.restangular.all("get_se_supplier_evaluation_masters");
  }

  public getApprovedSupplierEvaluationsTable() {
    return this.restangular.all("get_approved_se_masters");
  }

  public getSupplierEvaluationMaster() {
    return this.restangular.one("get_supplier_evaluation_master");
  }

  getSupplierEvaluationFormData() {
    return this.restangular.one("get_supplier_evaluation_form_data");
  }

  public confirmSuplierEvalutionForm() {
    return this.restangular.all("confirm_supplier_evaluation_form");
  }

  public createSupplierEvaluationCertificationType() {
    return this.restangular.all("se_certification_types");
  }

  public updateSupplierEvaluationCertificationType(id) {
    return this.restangular.all("se_certification_types/" + id);
  }

  public getSupplierEvaluationsCertificationTable() {
    return this.restangular.all("se_certification_types_table");
  }

  public getSeSupplierApprovals() {
    return this.restangular.one("get_se_approvals");
  }

  public getSeQuestionTypes() {
    return this.restangular.one("se_question_types");
  }

  public createSupplierEvaluationQuestions() {
    return this.restangular.all("se_question_masters");
  }

  public updateSupplierEvaluationQuestions(id) {
    return this.restangular.all("se_question_masters/" + id);
  }

  public getSupplierEvaluationsQuestionsTable() {
    return this.restangular.all("se_question_list");
  }

  public createSupplierEvaluationAuditFrequency() {
    return this.restangular.all("se_audit_frequencies");
  }

  public getSupplierEvaluationsAuditFrequencyTable() {
    return this.restangular.all("se_audit_frequencies_table");
  }

  public updateSupplierEvaluationAuditFrequency(id) {
    return this.restangular.all("se_audit_frequencies/" + id);
  }

  public getSupplierEvaluationsCategoryTable() {
    return this.restangular.all("se_category_table");
  }

  public createSupplierEvaluationCategory() {
    return this.restangular.all("se_supplier_categories");
  }

  public updateSupplierEvaluatioCategory(id) {
    return this.restangular.all("se_supplier_categories/" + id);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/supplier-evaluation.service.ts